// @import dependencies
import React, {Component} from 'react'
import { connect } from 'react-redux'
import { CombinedReducers as IState } from 'app_events/index'
// @end

// @import components
import {PaginationCommonLayout} from 'app_components/commons/pagination'
// @end

// @import events
// @end

// @import utils
// @end

// @import services
// @end

// @import types
import { IPagination } from 'app_types/pagination/paginationTypes'
// @end

// @ADD Component types
interface IPaginationCommonProps {
  version?: 'v1' | 'v2'
  data: IPagination
  onChangePage?: (page: number) => void
}
interface IPaginationCommonState {}

// @INFO: Connect react storage state
const mapStatesToProps = (state: IState) => {return state}

class PaginationCommon extends Component<IPaginationCommonProps, IPaginationCommonState> {

  /*===============================================
  =            Estructura de un metodo            =
  ================================================
    // La estructura de un metodo debe ser la siguiente:
    methodName = () => {}
  /*======  End of Estructura de un metodo  =====*/

  constructor(props: IPaginationCommonProps) {
    super(props)
    this.state = {}
  }

  /**
   * Evento que se ejecuta cuando el componente es montado
   */
  componentDidMount = async () => {}

  /**
   * Evento que se ejecuta cuando el componente es desmontado
   */
  componentWillUnmount = () => {}

  /**
   * Evento que se ejecuta cuando el componente es actualizado
   */
  componentDidUpdate = () => {}

  // @Add custom methods
  onNext = () => {
    if (this.props?.onChangePage) {
      const actualPage: number = this.props.data.page
      const totalPages = this.totalPages()

      if (actualPage < totalPages) {
        return this.props?.onChangePage(actualPage + 1)
      }
    }

    return false
  }

  onPrevious = () => {
    if (this.props?.onChangePage) {
      const actualPage: number = this.props.data.page

      if (actualPage > 1) {
        return this.props.onChangePage(actualPage - 1)
      }
    }

    return false

  }

  onPageNumber = (page: number) => {
    if (this.props?.onChangePage) {
      const actualPage: number = this.props.data.page

      if (page !== actualPage) {
        return this.props.onChangePage(page)
      }
    }

    return false
  }

  totalPages = (array?: boolean) => {
    let totalPages: number = 0

    if (this.props.data?.total > 0 && this.props.data.perPage > 0) {
      totalPages = Math.ceil(this.props.data?.total / this.props.data.perPage)
    }

    if (totalPages === NaN) {
      totalPages = 0
    }

    if (array) {
      const totalPagesArray = Array.apply(null, Array(totalPages)).map((_, idx) => idx)
      return totalPagesArray
    }
    return totalPages
  }

  render() {
    return(
      <PaginationCommonLayout
        version={this.props.version}
        data={this.props.data}
        onNext={this.onNext}
        onPrevious={this.onPrevious}
        onPageNumber={this.onPageNumber}
        totalPages={this.totalPages(true)}
      />
    )
  }
}

export default connect(mapStatesToProps)(PaginationCommon)
